import { createStore, applyMiddleware, compose } from 'redux'
import { createLogger } from 'redux-logger'
import throttle from 'lodash/throttle'
import rootReducer from '../reducers'
import createSagaMiddleware from 'redux-saga'
import combinedSaga from '../sagas'
import { saveState } from './localStorage'

function createAppStore(initialState) {
  const sagaMiddleware = createSagaMiddleware()
  const middlewares = [sagaMiddleware]

  if (process.env.NODE_ENV !== 'production') {
    middlewares.push(createLogger())
  }

  const enhancers = [applyMiddleware(...middlewares)]

  if (window.__REDUX_DEVTOOLS_EXTENSION__) {
    enhancers.push(window.__REDUX_DEVTOOLS_EXTENSION__())
  }

  const store = createStore(rootReducer, initialState, compose(...enhancers))

  sagaMiddleware.run(combinedSaga)

  return store
}

let store = null


function configureStore (initialState) {
  if (store) return store

  store = createAppStore(initialState)
  store.subscribe(throttle(() => {
    saveState({
      // configurationData: store.getState().configurationData
    })
  }, 1000))
  return store
}

function getStore() {
  return store
}

configureStore.getStore = getStore

export default configureStore